import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { oneWay } from '@ember/object/computed';
import Transition from '@ember/routing/-private/transition';
import SubscriptionCenterService from 'cio/services/subscription-center';

import NewsletterModel from 'cio/models/newsletter';
import DS from 'ember-data';

export interface NewsletterRouteParams {
  newsletter_id: string;
}

export default class NewsletterRoute extends Route {
  @service store!: DS.Store;
  @service subscriptionCenter!: SubscriptionCenterService;

  crumb() {
    let model = this.modelFor(this.routeName);

    return {
      name: oneWay('model.name'),
      path: this.routeName,
      model,
    };
  }

  model(params: NewsletterRouteParams) {
    return this.store.findRecord('newsletter', params.newsletter_id);
  }

  async beforeModel(transition: Transition) {
    await this.subscriptionCenter.initializeTask.perform();

    return super.beforeModel(transition);
  }

  async afterModel(model: NewsletterModel) {
    await model.get('templates');
  }
}
